import { render, staticRenderFns } from "./MegaphoneSimple.vue?vue&type=template&id=1e15968e"
import script from "./MegaphoneSimple.vue?vue&type=script&lang=js"
export * from "./MegaphoneSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports